import moment from 'moment'

function setStore (key, value) {
  window.sessionStorage.setItem(key, value)
}

function getStore (key) {
  let value = window.sessionStorage.getItem(key)
  return value
}

function removeStore (key) {
  window.sessionStorage.removeItem(key)
}

function setLocalStore (key, value) {
  window.localStorage.setItem(key, value)
}

function getLocalStore (key) {
  return window.localStorage.getItem(key)
}

function removeLocalStore (key) {
  window.localStorage.removeItem(key)
}

function formatTime (time) {
  return moment(time).format('YYYY-MM-DD HH:mm:ss')
}

function formatDate (time) {
  return moment(time).format('YYYY-MM-DD')
}

function checkPhone (phone) {
  let reg = /^1[3456789]\d{9}$/
  if (reg.test(phone)) {
    return true
  } else {
    return false
  }
}

function getDevice () {
  var u = navigator.userAgent
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1
  var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  if (isAndroid) {
    return 'android'
  }
  if (isIOS) {
    return 'ios'
  }
  return null
}

/**
 * 简单异或加解密
 * @param str
 * @param key
 * @returns {string}
 */
function xorEncrypt (str, key) {
  var res = ''
  let k
  for (var i = 0; i < str.length; i++) {
    if (i > key.length - 1) {
      k = i % key.length
    } else {
      k = i
    }
    res = res + String.fromCharCode(str.charCodeAt(i) ^ key.charCodeAt(k))
  }
  return res
}

export {
  getDevice,
  setStore,
  getStore,
  setLocalStore,
  getLocalStore,
  removeStore,
  removeLocalStore,
  formatTime,
  formatDate,
  checkPhone,
  xorEncrypt
}
